module.exports = __webpack_public_path__ + "static/media/social-media.72e2bd7f.svg";